import React, { useRef, useCallback, useState, useEffect } from 'react';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
import { IoChevronBack, IoChevronForward } from "react-icons/io5";
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/grid';
import { motion, useScroll } from "framer-motion";
import { MediaQueries } from '../utils';
// import required modules

export default function HomeCategories({ category_list, type }) {

  const { isMobile } = MediaQueries()

  const sliderRef = useRef(null);


  return (
    <div className='carousel_products'>
      <Swiper
        ref={sliderRef}
        breakpoints={{
          200: {
            slidesPerView: 2,
          },
          450: {
            slidesPerView: 2,
          },
          760: {
            slidesPerView: 4,
          },
          1000: {
            slidesPerView: 5,
          },
          1200: {
            slidesPerView: 5,
          },
          1400: {
            slidesPerView: type == 2 ? 3.5 : 7.5,
          },
          1600: {
            slidesPerView: type == 2 ? 3.5 : 7.5,
          }
        }}
        spaceBetween={10}
        className="carouselSwiper"
      >
        {
          category_list.map((cat_item) => {
            return (
              <SwiperSlide >
                <div className='product_container' style={{ height: '305px' }}>

                </div>
              </SwiperSlide>
            )
          })
        }
      </Swiper>
    </div>
  );
}
